import React, { useEffect, useState, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import { ArrowRight, Filter, tick } from "assets/images/imageData";
import localization from "assets/localization/localization";
import PaymentFilter from "components/sales/ListFilters/PaymentFilter";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import Images from "assets/images/imageData";
import AddPaymentPopup from "components/sales/paymentPortal/addPayment/addPaymentPopup";
import AdjustAdvancePopup from "components/sales/paymentPortal/adjustAdvance/adjustAdvancePopup";
import ViewDetailsPopup from "components/sales/paymentPortal/viewDetails/viewDetails";
import CustomModal from "../../valetServices/modal";
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import PanelCardWithHeading from "../../../components/tickets/panelCardWithHeading";
import $ from "jquery";
import { toast } from "react-toastify";

const InvoiceLob = ({
  getTaxInvoiceLob,
  postSalesList,
  getListFilterData,
  filterDropdownList = null,
  fetchZones,
  getFetchZones = null,
  getReportee,
  reportee,
  newAssigneeRes = [],
  bulkAssigneTaxInvoices
}) => {
  const headers = [
    "Site Number",
    "Invoice Number",
    "Invoice Date",
    "Business",
    "Revenue Nature",
    "Total Amount",
    "Due date",
    "Status",
    "Pending Amount",
    "Invoice Age",
    "Assignee Email",
    "Action",
  ];
  const [listData, setListData] = useState();
  const [activePostSales, setActivePostSales] = useState();
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [showAddPaymentPopup, setShowAddPaymentPopup] = useState(false);
  const [showAdjustAdvancePopup, setShowAdjustAdvancePopup] = useState(false);
  const [showDetailsPopup, setShowDetailsPopup] = useState(false);
  const [currentBusinessId, setCurrentBusinessId] = useState('');
  const [currentInvoiceId, setCurrentInvoiceId] = useState('');
  const [currentContractId, setCurrentContractId] = useState('');
  const [currentSiteNumber, setCurrentSiteNumber] = useState('');
  const [currentBusinessName, setCurrentBusinessName] = useState('');
  const [invoiceNumbers, setInvoiceNumbers] = useState([]);
  const [newAssigneeUser, setNewAssingeeUser] = useState("");
  const [notify, setNotify] = useState("");
  const [count, setCount] = useState(0);
  const [isAllChecked, setIsAllChecked] = useState(false);

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem("roles"));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);

  useEffect(() => {
    (async () => {
        await getReportee(100);
    })();
}, [getReportee]);

const makeAllChecked = (e) => {
    if(e.target.checked){
        setIsAllChecked(true)
        $("input[type=checkbox]").prop('checked', true)
    }else{
        invoiceNumbers.length = 0
        setInvoiceNumbers([]);
        setIsAllChecked(false)
        $("input[type=checkbox]").prop('checked', false)
    }
}

const handleOnSubmitForm = async () => {
    if(newAssigneeUser === ""){
        toast.warning('New assignee is required.');
        return false;
    }
    if(isAllChecked === true) {
        setInvoiceNumbers([]);  
        postSalesList.resultSets.map((element) => {
            invoiceNumbers.push(element?.invoice_id !== null && element?.invoice_id !== undefined ? element?.invoice_id : null)
        });
    }
    if(invoiceNumbers.length <= 0) {
        toast.warning('No tax invoice is selected.');
        return false;
    }
    const data = {
        'new_assigned_id':newAssigneeUser,
        'invoices':invoiceNumbers
    }
    // console.log(data);
    // return false;
    setIsLoading(true)
    let res = await bulkAssigneTaxInvoices(data);
    if(res === true) {  
       setNotify(200);
    } else {
       setNotify(404);
    }
    setIsLoading(false);
    setCount(count+1);
    // window.location.reload()
}

  const createLead = async () => {
    if (departmentId && departmentId === 2) {
      if (teamId && teamId === 7) {
        setActivePostSales("post-sales-corporate");
      } else if (teamId && teamId === 9) {
        setActivePostSales("post-sales-supply");
      } else if (teamId && teamId === 8) {
        setActivePostSales("post-sales-apartment");
      } else {
        setActivePostSales("post-sales-b2b-alliance");
      }
    }
  };


  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useEffect(() => {
    if (teamId && departmentId) {
      createLead();
    }
  }, [teamId, departmentId]);

  useEffect(() => {
    if (getTaxInvoiceLob !== null) {
      (async () => {
        setIsLoading(true);
        await getTaxInvoiceLob(null, 1);
        setIsLoading(false);
      })();
    }
  }, [getTaxInvoiceLob]);

  const handleAddRemoveInvoiceNumber = (e, invId) => {
    if(e.target.checked){
        invoiceNumbers.push(invId)
        //console.log("Invoice Number "+invoiceNumbers)
        setInvoiceNumbers(invoiceNumbers)
    } else{
        var index = invoiceNumbers.indexOf(invId);
        if (index !== -1) {
            invoiceNumbers.splice(index, 1);
            setIsAllChecked(false);
        }
    }
  }
  
  useEffect(() => {
    const tableData = [
      "id",
      "site_number",
      "invoice_number",
      "invoice_date",
      "business",
      "revenue_nature",
      "total_amount",
      "due_date",
      "status",
      "pending_amount",
      "invoice_age",
      "email",
      "action"
    ];

    if (postSalesList !== {} && postSalesList.resultSets) {
      const data = postSalesList.resultSets.map((element) =>
      Object.assign(
        {},
        ...tableData.map((key) => (key === 'action' ?  {
                ['action']:
                    <input style={{"marginLeft":"18px"}} type="checkbox"
                           value={element?.invoice_id}
                           onChange={(e) => handleAddRemoveInvoiceNumber(e, element?.invoice_id)}
                           required
                    />
        }:
            { [key]: element[key] })),
        ),
      );
      data && setListData(data);
      setPageCount(Math.ceil(postSalesList.total / postSalesList.per_page));
    }
  }, [postSalesList]);

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getTaxInvoiceLob(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      await getListFilterData(2);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const headerBtns = () => {
    return (
      <Fragment>
         {/* <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
         >
          {localization.showFilters}
        </Button>  */}
      </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getTaxInvoiceLob(filter, val.selected + 1);
    setIsLoading(false);
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.taxInv}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <div className="row">
        {newAssigneeRes !== [] && notify !== 200 &&
            <CustomModal msg={'Something went wrong.'} isPageLoad={true}  click={count}/>}
        {newAssigneeRes !== [] && notify === 200 &&
            <CustomModal msg={`Tax invoice assigned successfully.`}  isPageLoad={true} click={count}/>}
        <div className="col-md-3 col-sm-12">
            <DropDownInput
                label={localization.changeAssignedUser}
                data={reportee}
                getIdValue={async (val) => {
                    setNewAssingeeUser(val.id)
                }}
            />
        </div>
        <center><Button onClick={handleOnSubmitForm}>
            {localization.changeTIAssignee}
        </Button>
        </center>
      </div>
      <div style={{"overflow":"hidden"}}>
        <PanelCardWithHeading title={localization.taxInvLob}>
            <>
                <div>
                    <p style={{"right":"9%", "marginBottom":"-21px", "position":"relative","float":"right","top":"-2px"}}>Assign All</p>
                    <input type="checkbox"
                            value=""
                            onChange={() => {}}
                            required
                            style={{"position":"relative","left":"44%","marginBottom":"29px"}}
                            onClick={(e) => {makeAllChecked(e)}}
                    />
                </div>

                <TableSection
                    data={listData}
                    isId={false}
                    headers={headers}
                    detailList={postSalesList && postSalesList.resultSets}
                    pageCount={pageCount}
                    srNo={postSalesList?.from}
                    onPageChange={onPageChange}
                    setShowAddPaymentPopup={setShowAddPaymentPopup}
                    setShowAdjustAdvancePopup={setShowAdjustAdvancePopup}
                    setShowDetailsPopup={setShowDetailsPopup}
                    setCurrentBusinessId={setCurrentBusinessId}
                    setCurrentContractId={setCurrentContractId}
                    setCurrentInvoiceId={setCurrentInvoiceId}
                    setCurrentSiteNumber={setCurrentSiteNumber}
                    setCurrentBusinessName={setCurrentBusinessName}
                />
            </>
        </PanelCardWithHeading>
      </div>

      <PaymentFilter
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={"5"}
        getZones={(val) => getZones(val)}
        listFilterData={filterDropdownList && filterDropdownList.data}
        zones={getFetchZones && getFetchZones.data}
        isRoleId={isRoleId}
        invoiceFilters
      />

      <AddPaymentPopup
        showPaymentPopup={showAddPaymentPopup}
        onClosePopup={() => setShowAddPaymentPopup(false)}
        businessId={currentBusinessId}
        invoiceId={currentInvoiceId}
        contractId={currentContractId}
        siteNumber={currentSiteNumber}
        businessName={currentBusinessName}
      />
      {showAdjustAdvancePopup && <AdjustAdvancePopup
        showAdjustAdvancePopup={showAdjustAdvancePopup}
        onClosePopup={() => setShowAdjustAdvancePopup(false)}
        businessId={currentBusinessId}
        invoiceId={currentInvoiceId}
        contractId={currentContractId}
        siteNumber={currentSiteNumber}
        businessName={currentBusinessName}
      />}
      
      {showDetailsPopup && <ViewDetailsPopup 
        showViewDetailsPopup={showDetailsPopup}
        onClosePopup={() => setShowDetailsPopup(false)}
        invoiceId={currentInvoiceId}
      />}
    </Layout>
  );
};

export default InvoiceLob;
